import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDirectionChevronDown16 = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps, ref: Ref<SVGSVGElement>) => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M0.666504 4C4.2865 4.37667 7.8765 9.4 7.99984 12C8.11984 9.4 11.7132 4.37667 15.3332 4" stroke="currentColor" /></svg>;
const ForwardRef = forwardRef(SvgDirectionChevronDown16);
export default ForwardRef;